import { produce } from 'immer';

import { ShowInternalBannerImageLinkInput } from '../../../actions/imageEditor/internal/showInternalBannerImageLinkInput';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageOrCreativeUploadingMode } from '../../../typings/banners';
import { ImageEditorsState } from '../../../typings/state';

export function showInternalBannerImageLinkInput(
    state: ImageEditorsState,
    action: ShowInternalBannerImageLinkInput
): ImageEditorsState {
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        draft[id].image.mode = ImageOrCreativeUploadingMode.ENTER_LINK;
        draft[id].image.isUploadByLink = true;
        draft[id].image.errors = undefined;
    });
}
